import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.math.hypot.js";
import t, { PureComponent as e } from "react";
function i(t, e, i, n) {
  return new (i || (i = Promise))(function (s, r) {
    function l(t) {
      try {
        o(n.next(t));
      } catch (t) {
        r(t);
      }
    }
    function a(t) {
      try {
        o(n.throw(t));
      } catch (t) {
        r(t);
      }
    }
    function o(t) {
      var e;
      t.done ? s(t.value) : (e = t.value, e instanceof i ? e : new i(function (t) {
        t(e);
      })).then(l, a);
    }
    o((n = n.apply(t, e || [])).next());
  });
}
var n = function n(t, e, i, _n) {
    t.style.transition = "".concat(e, " ").concat(i, "ms ").concat(_n);
  },
  s = function s(t, e, i) {
    return Math.min(Math.max(t, e), i);
  };
var r = /*#__PURE__*/_createClass(function r(t, e) {
  var _this = this;
  _classCallCheck(this, r);
  this.glareAngle = 0, this.glareOpacity = 0, this.calculateGlareSize = function (t) {
    var e = t.width,
      i = t.height,
      n = Math.sqrt(Math.pow(e, 2) + Math.pow(i, 2));
    return {
      width: n,
      height: n
    };
  }, this.setSize = function (t) {
    var e = _this.calculateGlareSize(t);
    _this.glareEl.style.width = "".concat(e.width, "px"), _this.glareEl.style.height = "".concat(e.height, "px");
  }, this.update = function (t, e, i, n) {
    _this.updateAngle(t, e.glareReverse), _this.updateOpacity(t, e, i, n);
  }, this.updateAngle = function (t, e) {
    var i = t.xPercentage,
      n = t.yPercentage,
      s = 180 / Math.PI,
      _r2 = i ? Math.atan2(n, -i) * s : 0;
    _this.glareAngle = _r2 - (e ? 180 : 0);
  }, this.updateOpacity = function (t, e, i, n) {
    var _r3 = t.xPercentage,
      l = t.yPercentage,
      a = e.glarePosition,
      o = e.glareReverse,
      h = e.glareMaxOpacity,
      p = i ? -1 : 1,
      c = n ? -1 : 1,
      g = o ? -1 : 1;
    var d = 0;
    switch (a) {
      case "top":
        d = -_r3 * p * g;
        break;
      case "right":
        d = l * c * g;
        break;
      case "bottom":
      case void 0:
        d = _r3 * p * g;
        break;
      case "left":
        d = -l * c * g;
        break;
      case "all":
        d = Math.hypot(_r3, l);
    }
    var u = s(d, 0, 100);
    _this.glareOpacity = u * h / 100;
  }, this.render = function (t) {
    var e = t.glareColor;
    _this.glareEl.style.transform = "rotate(".concat(_this.glareAngle, "deg) translate(-50%, -50%)"), _this.glareEl.style.opacity = _this.glareOpacity.toString(), _this.glareEl.style.background = "linear-gradient(0deg, rgba(255,255,255,0) 0%, ".concat(e, " 100%)");
  }, this.glareWrapperEl = document.createElement("div"), this.glareEl = document.createElement("div"), this.glareWrapperEl.appendChild(this.glareEl), this.glareWrapperEl.className = "glare-wrapper", this.glareEl.className = "glare";
  var i = {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      borderRadius: e,
      WebkitMaskImage: "-webkit-radial-gradient(white, black)",
      pointerEvents: "none"
    },
    n = this.calculateGlareSize(t),
    _r = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transformOrigin: "0% 0%",
      pointerEvents: "none",
      width: "".concat(n.width, "px"),
      height: "".concat(n.height, "px")
    };
  Object.assign(this.glareWrapperEl.style, i), Object.assign(this.glareEl.style, _r);
});
var l = /*#__PURE__*/_createClass(function l() {
  var _this2 = this;
  _classCallCheck(this, l);
  this.glareAngle = 0, this.glareOpacity = 0, this.tiltAngleX = 0, this.tiltAngleY = 0, this.tiltAngleXPercentage = 0, this.tiltAngleYPercentage = 0, this.update = function (t, e) {
    _this2.updateTilt(t, e), _this2.updateTiltManualInput(t, e), _this2.updateTiltReverse(e), _this2.updateTiltLimits(e);
  }, this.updateTilt = function (t, e) {
    var i = t.xPercentage,
      n = t.yPercentage,
      s = e.tiltMaxAngleX,
      r = e.tiltMaxAngleY;
    _this2.tiltAngleX = i * s / 100, _this2.tiltAngleY = n * r / 100 * -1;
  }, this.updateTiltManualInput = function (t, e) {
    var i = e.tiltAngleXManual,
      n = e.tiltAngleYManual,
      s = e.tiltMaxAngleX,
      r = e.tiltMaxAngleY;
    (null !== i || null !== n) && (_this2.tiltAngleX = null !== i ? i : 0, _this2.tiltAngleY = null !== n ? n : 0, t.xPercentage = 100 * _this2.tiltAngleX / s, t.yPercentage = 100 * _this2.tiltAngleY / r);
  }, this.updateTiltReverse = function (t) {
    var e = t.tiltReverse ? -1 : 1;
    _this2.tiltAngleX = e * _this2.tiltAngleX, _this2.tiltAngleY = e * _this2.tiltAngleY;
  }, this.updateTiltLimits = function (t) {
    var e = t.tiltAxis;
    _this2.tiltAngleX = s(_this2.tiltAngleX, -90, 90), _this2.tiltAngleY = s(_this2.tiltAngleY, -90, 90);
    e && (_this2.tiltAngleX = "x" === e ? _this2.tiltAngleX : 0, _this2.tiltAngleY = "y" === e ? _this2.tiltAngleY : 0);
  }, this.updateTiltAnglesPercentage = function (t) {
    var e = t.tiltMaxAngleX,
      i = t.tiltMaxAngleY;
    _this2.tiltAngleXPercentage = _this2.tiltAngleX / e * 100, _this2.tiltAngleYPercentage = _this2.tiltAngleY / i * 100;
  }, this.render = function (t) {
    t.style.transform += "rotateX(".concat(_this2.tiltAngleX, "deg) rotateY(").concat(_this2.tiltAngleY, "deg) ");
  };
});
var a = Object.assign(Object.assign({
  scale: 1,
  perspective: 1e3,
  flipVertically: !1,
  flipHorizontally: !1,
  reset: !0,
  transitionEasing: "cubic-bezier(.03,.98,.52,.99)",
  transitionSpeed: 400,
  trackOnWindow: !1,
  gyroscope: !1
}, {
  tiltEnable: !0,
  tiltReverse: !1,
  tiltAngleXInitial: 0,
  tiltAngleYInitial: 0,
  tiltMaxAngleX: 20,
  tiltMaxAngleY: 20,
  tiltAxis: void 0,
  tiltAngleXManual: null,
  tiltAngleYManual: null
}), {
  glareEnable: !1,
  glareMaxOpacity: .7,
  glareColor: "#ffffff",
  glarePosition: "bottom",
  glareReverse: !1,
  glareBorderRadius: "0"
});
var o = /*#__PURE__*/function (_e) {
  _inherits(o, _e);
  var _super = _createSuper(o);
  function o() {
    var _this3;
    _classCallCheck(this, o);
    _this3 = _super.apply(this, arguments), _this3.wrapperEl = {
      node: null,
      size: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      clientPosition: {
        x: null,
        y: null,
        xPercentage: 0,
        yPercentage: 0
      },
      updateAnimationId: null,
      scale: 1
    }, _this3.tilt = null, _this3.glare = null, _this3.addDeviceOrientationEventListener = function () {
      return i(_assertThisInitialized(_this3), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var t;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (window.DeviceOrientationEvent) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              t = DeviceOrientationEvent.requestPermission;
              if (!("function" == typeof t)) {
                _context.next = 12;
                break;
              }
              _context.next = 6;
              return t();
            case 6:
              _context.t0 = _context.sent;
              _context.t1 = "granted" === _context.t0;
              if (!_context.t1) {
                _context.next = 10;
                break;
              }
              window.addEventListener("deviceorientation", this.onMove);
            case 10:
              _context.next = 13;
              break;
            case 12:
              window.addEventListener("deviceorientation", this.onMove);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }, _this3.setSize = function () {
      _this3.setWrapperElSize(), _this3.glare && _this3.glare.setSize(_this3.wrapperEl.size);
    }, _this3.mainLoop = function (t) {
      null !== _this3.wrapperEl.updateAnimationId && cancelAnimationFrame(_this3.wrapperEl.updateAnimationId), _this3.processInput(t), _this3.update(t.type), _this3.wrapperEl.updateAnimationId = requestAnimationFrame(_this3.renderFrame);
    }, _this3.onEnter = function (t) {
      var e = _this3.props.onEnter;
      _this3.setSize(), _this3.wrapperEl.node.style.willChange = "transform", _this3.setTransitions(), e && e(t.type);
    }, _this3.onMove = function (t) {
      _this3.mainLoop(t), _this3.emitOnMove(t);
    }, _this3.onLeave = function (t) {
      var e = _this3.props.onLeave;
      if (_this3.setTransitions(), e && e(t.type), _this3.props.reset) {
        var _t = new CustomEvent("autoreset");
        _this3.onMove(_t);
      }
    }, _this3.processInput = function (t) {
      var e = _this3.props.scale;
      switch (t.type) {
        case "mousemove":
          _this3.wrapperEl.clientPosition.x = t.pageX, _this3.wrapperEl.clientPosition.y = t.pageY, _this3.wrapperEl.scale = e;
          break;
        case "touchmove":
          _this3.wrapperEl.clientPosition.x = t.touches[0].pageX, _this3.wrapperEl.clientPosition.y = t.touches[0].pageY, _this3.wrapperEl.scale = e;
          break;
        case "deviceorientation":
          _this3.processInputDeviceOrientation(t), _this3.wrapperEl.scale = e;
          break;
        case "autoreset":
          var _this3$props = _this3.props,
            _i = _this3$props.tiltAngleXInitial,
            _n2 = _this3$props.tiltAngleYInitial,
            _r4 = _this3$props.tiltMaxAngleX,
            _l = _this3$props.tiltMaxAngleY,
            _a = _n2 / _l * 100;
          _this3.wrapperEl.clientPosition.xPercentage = s(_i / _r4 * 100, -100, 100), _this3.wrapperEl.clientPosition.yPercentage = s(_a, -100, 100), _this3.wrapperEl.scale = 1;
      }
    }, _this3.processInputDeviceOrientation = function (t) {
      if (!t.gamma || !t.beta || !_this3.props.gyroscope) return;
      var _this3$props2 = _this3.props,
        e = _this3$props2.tiltMaxAngleX,
        i = _this3$props2.tiltMaxAngleY,
        n = t.gamma;
      _this3.wrapperEl.clientPosition.xPercentage = t.beta / e * 100, _this3.wrapperEl.clientPosition.yPercentage = n / i * 100, _this3.wrapperEl.clientPosition.xPercentage = s(_this3.wrapperEl.clientPosition.xPercentage, -100, 100), _this3.wrapperEl.clientPosition.yPercentage = s(_this3.wrapperEl.clientPosition.yPercentage, -100, 100);
    }, _this3.update = function (t) {
      var _this3$props3 = _this3.props,
        e = _this3$props3.tiltEnable,
        i = _this3$props3.flipVertically,
        n = _this3$props3.flipHorizontally;
      "autoreset" !== t && "deviceorientation" !== t && "propChange" !== t && _this3.updateClientInput(), e && _this3.tilt.update(_this3.wrapperEl.clientPosition, _this3.props), _this3.updateFlip(), _this3.tilt.updateTiltAnglesPercentage(_this3.props), _this3.glare && _this3.glare.update(_this3.wrapperEl.clientPosition, _this3.props, i, n);
    }, _this3.updateClientInput = function () {
      var t = _this3.props.trackOnWindow;
      var e, i;
      if (t) {
        var _this3$wrapperEl$clie = _this3.wrapperEl.clientPosition,
          _t2 = _this3$wrapperEl$clie.x,
          _n3 = _this3$wrapperEl$clie.y;
        e = _n3 / window.innerHeight * 200 - 100, i = _t2 / window.innerWidth * 200 - 100;
      } else {
        var _this3$wrapperEl = _this3.wrapperEl,
          _this3$wrapperEl$size = _this3$wrapperEl.size,
          _t3 = _this3$wrapperEl$size.width,
          _n4 = _this3$wrapperEl$size.height,
          _s = _this3$wrapperEl$size.left,
          _r5 = _this3$wrapperEl$size.top,
          _this3$wrapperEl$clie2 = _this3$wrapperEl.clientPosition,
          _l2 = _this3$wrapperEl$clie2.x,
          _a2 = _this3$wrapperEl$clie2.y;
        e = (_a2 - _r5) / _n4 * 200 - 100, i = (_l2 - _s) / _t3 * 200 - 100;
      }
      _this3.wrapperEl.clientPosition.xPercentage = s(e, -100, 100), _this3.wrapperEl.clientPosition.yPercentage = s(i, -100, 100);
    }, _this3.updateFlip = function () {
      var _this3$props4 = _this3.props,
        t = _this3$props4.flipVertically,
        e = _this3$props4.flipHorizontally;
      t && (_this3.tilt.tiltAngleX += 180, _this3.tilt.tiltAngleY *= -1), e && (_this3.tilt.tiltAngleY += 180);
    }, _this3.renderFrame = function () {
      _this3.resetWrapperElTransform(), _this3.renderPerspective(), _this3.tilt.render(_this3.wrapperEl.node), _this3.renderScale(), _this3.glare && _this3.glare.render(_this3.props);
    };
    return _this3;
  }
  _createClass(o, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.tilt = new l(), this.initGlare(), this.addEventListeners(), "undefined" == typeof CustomEvent) return;
      var t = new CustomEvent("autoreset");
      this.mainLoop(t);
      var e = new CustomEvent("initial");
      this.emitOnMove(e);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      null !== this.wrapperEl.updateAnimationId && cancelAnimationFrame(this.wrapperEl.updateAnimationId), this.removeEventListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var t = new CustomEvent("propChange");
      this.mainLoop(t), this.emitOnMove(t);
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$props = this.props,
        t = _this$props.trackOnWindow,
        e = _this$props.gyroscope;
      window.addEventListener("resize", this.setSize), t && (window.addEventListener("mouseenter", this.onEnter), window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseout", this.onLeave), window.addEventListener("touchstart", this.onEnter), window.addEventListener("touchmove", this.onMove), window.addEventListener("touchend", this.onLeave)), e && this.addDeviceOrientationEventListener();
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this$props2 = this.props,
        t = _this$props2.trackOnWindow,
        e = _this$props2.gyroscope;
      window.removeEventListener("resize", this.setSize), t && (window.removeEventListener("mouseenter", this.onEnter), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseout", this.onLeave), window.removeEventListener("touchstart", this.onEnter), window.removeEventListener("touchmove", this.onMove), window.removeEventListener("touchend", this.onLeave)), e && window.DeviceOrientationEvent && window.removeEventListener("deviceorientation", this.onMove);
    }
  }, {
    key: "setWrapperElSize",
    value: function setWrapperElSize() {
      var t = this.wrapperEl.node.getBoundingClientRect();
      this.wrapperEl.size.width = this.wrapperEl.node.offsetWidth, this.wrapperEl.size.height = this.wrapperEl.node.offsetHeight, this.wrapperEl.size.left = t.left + window.scrollX, this.wrapperEl.size.top = t.top + window.scrollY;
    }
  }, {
    key: "initGlare",
    value: function initGlare() {
      var _this$props3 = this.props,
        t = _this$props3.glareEnable,
        e = _this$props3.glareBorderRadius;
      t && (this.glare = new r(this.wrapperEl.size, e), this.wrapperEl.node.appendChild(this.glare.glareWrapperEl));
    }
  }, {
    key: "emitOnMove",
    value: function emitOnMove(t) {
      var e = this.props.onMove;
      if (!e) return;
      var i = 0,
        n = 0;
      this.glare && (i = this.glare.glareAngle, n = this.glare.glareOpacity), e({
        tiltAngleX: this.tilt.tiltAngleX,
        tiltAngleY: this.tilt.tiltAngleY,
        tiltAngleXPercentage: this.tilt.tiltAngleXPercentage,
        tiltAngleYPercentage: this.tilt.tiltAngleYPercentage,
        glareAngle: i,
        glareOpacity: n,
        eventType: t.type
      });
    }
  }, {
    key: "resetWrapperElTransform",
    value: function resetWrapperElTransform() {
      this.wrapperEl.node.style.transform = "";
    }
  }, {
    key: "renderPerspective",
    value: function renderPerspective() {
      var t = this.props.perspective;
      this.wrapperEl.node.style.transform += "perspective(".concat(t, "px) ");
    }
  }, {
    key: "renderScale",
    value: function renderScale() {
      var t = this.wrapperEl.scale;
      this.wrapperEl.node.style.transform += "scale3d(".concat(t, ",").concat(t, ",").concat(t, ")");
    }
  }, {
    key: "setTransitions",
    value: function setTransitions() {
      var _this$props4 = this.props,
        t = _this$props4.transitionSpeed,
        e = _this$props4.transitionEasing;
      n(this.wrapperEl.node, "all", t, e), this.glare && n(this.glare.glareEl, "opacity", t, e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props5 = this.props,
        e = _this$props5.children,
        i = _this$props5.className,
        n = _this$props5.style;
      return t.createElement("div", {
        ref: function ref(t) {
          return _this4.wrapperEl.node = t;
        },
        onMouseEnter: this.onEnter,
        onMouseMove: this.onMove,
        onMouseLeave: this.onLeave,
        onTouchStart: this.onEnter,
        onTouchMove: this.onMove,
        onTouchEnd: this.onLeave,
        className: i,
        style: n
      }, e);
    }
  }]);
  return o;
}(e);
o.defaultProps = a;
export { o as default };